
import sld from "../../../images/sld/Rectangle.svg";
import embLabels from "../../../config/emb-labels-en.json";
import { useContext } from "react";
import { DesignAssetContext } from "../../../pages/CustomHooks/ContextApi";
import Ecc from "../SLD/Ecc";
import BusbarSVG from "../SLD/BusbarSVG";
import Utility from "./Utility";
import Genset from "./Genset";
import Battery from "./Battery";
import PV from "./PV";
import Load from "./Load";
import Ev from "./Ev";
import LinebarSLD from "../SLD/LinebarSLD";
const EmaIslandableEtoSLD = () => {
  const {
    CBAssetList,
    CBEVList,
    CBLoadList,
    pv1SelectHandler,
    pv2SelectHandler,
    pv3SelectHandler,
    sldLoadCompleted,
    projectKind,
    switchboardType,
    count,
    loadSide,
  } = useContext(DesignAssetContext);
  const areAllConfigured = () => {
    return CBLoadList.every(item => item.uiData.configured);
  }
  const getLoadXPosition = () => {
    if (switchboardType === embLabels?.EXISTING_SWITCHBOARD) {
      return count?.derCount === 6
        ? count?.evCount === 1 ? 190 : 165
        : count?.derCount === 5
          ? count?.evCount === 1 ? 180 : 108
          : count?.derCount === 4
            ? count?.evCount === 1 ?  120 : 70
            : count.derCount === 3
              ? count?.evCount === 1 ?  80 : 40 : 0
    } else {
      return count?.derCount === 6 ?
        count?.evCount === 1 ? 160 : 100 :
        count?.derCount === 5
          ? count?.evCount === 1 ? 100 : 50
          : count?.derCount === 4
            ? count?.evCount === 1 ? 40 : 10
            : count.derCount === 3
              ?  count?.evCount === 1 ? 10 : -50:0
    }


  }
  const getEvXPosition = () => {
    if (switchboardType === embLabels?.EXISTING_SWITCHBOARD) {
      return count?.derCount === 6
        ? 650
        : count?.derCount === 5
          ? 620
          : count?.derCount === 4
            ? 570
            : count?.derCount === 3
              ? 510
              : 0
    } else {
      return count?.derCount === 6
        ? 600
        : count?.derCount === 5
          ? 550
          : count?.derCount === 4
            ? 500
            : count?.derCount === 3
              ? 460
              : 0
    }

  }
  const getEccPosition = () => {
    let position = {
      x: 360,
      y: 269,
      width: 500,
      height: 188,
      rx: 16,
      labelX: 500,
      labelY: 440
    }
    if (switchboardType === embLabels.EXISTING_SWITCHBOARD) {
      position.width = count?.derCount === 6 ? 625 : count?.derCount === 5 ? 520 : count?.derCount === 4 ? 420 : 300;
      position.labelX= count?.derCount ===3 ?460:count?.derCount ===4 ?590:count?.derCount ===6 ?800: 490;
    } else {
      position.width = count?.derCount === 6 ? 770 : count?.derCount === 5 ? 655 : count?.derCount === 4 ? 550 : 450;
      position.labelX = count?.derCount === 6 ? 900 : count?.derCount === 5 ? 800 : count?.derCount === 4 ? 690 : 500;
    }

    return position;
  }
  const getExistingBoardPosition = () => {
    const position = {
      x: 40,
      y: 170,
      width: 350,
      height: 205.3,
      rx: 16,
      labelX: 160,
      labelY: 360
    }
    return position;
  };
  const getBusbarPosition = () => {
    const positions = {
      x1: 410,
      y1: 370,
      x2: 800,
      y2: 370,
    };
    if (switchboardType === embLabels.EXISTING_SWITCHBOARD) {
      positions.x1 = 550;
      positions.y1 = 471;
      positions.x2 = count?.derCount === 6 ? 1100 : count?.derCount === 5 ? 1000 : count?.derCount === 4 ? 900 : 780;
      positions.y2 = 471;
    } else {
      positions.x2 = count?.derCount === 6 ? 1070 : count?.derCount === 5 ? 970 : count?.derCount === 4 ? 860 : 770;
    }
    return positions;
  };

  const getExistingBusbarPosition = () => {
    const positions = {
      x1: 90,
      y1: 272,
      x2: 345,
      y2: 272,
    };
    return positions;
  }

  const getPvRenderList = () => {
    const baseX = 720; // common x for PV component
    const baseY = 140;
    const px = 725;
    const cx = 820;
    const slotWidth = 100; // pvX increment per visible PV

    const pvAssets = [
      { id: "Pv1", index: 3 },
      { id: "Pv2", index: 4 },
      { id: "Pv3", index: 5 },
    ];

    const visible = pvAssets.filter(({ index }) => CBAssetList[index]?.uiData?.status);

    return visible.map(({ id, index }, i) => ({
      id,
      index,
      pvX: i * slotWidth,
      x: baseX,
      y: baseY,
      px,
      cx,
      selectHandler: index === 3 ? pv1SelectHandler : index === 4 ? pv2SelectHandler : pv3SelectHandler,
    }));
  };
  return (
    <div
      id="SLD-Image"
      className="col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0"
    >
      <svg viewBox="0 0 1300 800">
        <g>
          <svg x="0" y="0" viewBox="0 0 1300 800">
            <g id="grid">
              <svg>
                <image href={sld} x="0" y="0" />
              </svg>
            </g>
            <svg x={switchboardType === embLabels?.EXISTING_SWITCHBOARD ? 0 : count?.derCount === 6 ? -80 : count?.derCount === 5 ? -60 : ""}>
              <g
                id="components-sld"
                style={sldLoadCompleted ? {} : { display: "none" }}
              >
                <svg>
                  {switchboardType === embLabels?.EXISTING_SWITCHBOARD ?
                    <>
                      <svg x="0" y="0">
                        <Ecc
                          boardLabel=" Existing Switchboard"
                          existingBoardPosition={getExistingBoardPosition()}
                        />
                      </svg>
                      <svg x="150" y="100">
                        <Ecc
                          boardLabel=" Energy Control Center"
                          existingBoardPosition={getEccPosition()}
                        />
                      </svg>

                    </> :
                    <Ecc
                      boardLabel=" Low Voltage Switchboard"
                      existingBoardPosition={getEccPosition()}
                    />
                  }
                  {switchboardType === embLabels?.EXISTING_SWITCHBOARD ?
                    <>
                      <BusbarSVG barPositions={getExistingBusbarPosition()} />
                      <BusbarSVG barPositions={getBusbarPosition()} />
                    </> :
                    <BusbarSVG barPositions={getBusbarPosition()} />
                  }
                </svg>
                  <svg>
                      <svg x={count?.derCount == 3 ||count?.derCount == 4 || count?.derCount == 5 || count?.derCount == 6 ? -50 : -15} y={0}>
                  
                <Utility />
                </svg>
                <svg x={count?.derCount == 4 || count?.derCount == 5 || count?.derCount == 6 ?switchboardType === embLabels?.EXISTING_SWITCHBOARD ?0: -50 : switchboardType !== embLabels?.EXISTING_SWITCHBOARD &&count?.derCount == 3 ?-55: -15} y={switchboardType === embLabels?.EXISTING_SWITCHBOARD ?100 : 0}>
                  
                  {CBAssetList[1].uiData.status && <Genset />}
                  {CBAssetList[2].uiData.status && <Battery />}
                 <svg x={CBAssetList[1].uiData.status?0:-100}>
                   {getPvRenderList().map(({ id, index, pvX, x, y, px, cx, selectHandler }) => (
                    <PV
                      key={id}
                      id={id}
                      pvX={pvX}
                      x={x}
                      y={y}
                      px={px}
                      cx={cx}
                      selectHandler={selectHandler}
                      index={index}
                    />
                  ))}
                 </svg>
                </svg>
                  </svg>
                {
                switchboardType === embLabels?.EXISTING_SWITCHBOARD && (
                  <LinebarSLD />
                )}
                
                <svg
                  id="load pointer1"
                  x={getLoadXPosition()}
                  y={switchboardType === embLabels?.EXISTING_SWITCHBOARD ? 102 : 0}
                >

                  {CBLoadList.length > 0 && <Load  configured = {areAllConfigured()}/>}
                </svg>
                <svg
                  x={getEvXPosition()}
                  y={switchboardType === embLabels?.EXISTING_SWITCHBOARD ?"469":"369"}
                >
                  {CBEVList.map(
                    (cbData, key) =>
                      cbData.uiData.status && (
                        <Ev key={cbData.configData.name} index={key} status={cbData.uiData.status} />
                      )
                  )}
                </svg>

              </g>
            </svg>
          </svg>
        </g>
      </svg>
    </div>
  );
};

export default EmaIslandableEtoSLD;
